export default __webpack_public_path__ + "static/media/pgmico(41).1dda8842.png";